import React, { useState, useEffect } from 'react';

const TextInputFilter = ({
    onChange,
    placeholder = 'Search...'
}) => {
    const [value, setValue] = useState('');

    const handleChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        onChange(newValue);
    };

    return (
        <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            style={{
                width: '100%',
                height: '38px',
                fontSize: '12px',
                padding: '8px 12px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                boxSizing: 'border-box'
            }}
        />
    );
};

export default TextInputFilter;
